import swal from "sweetalert";

import { InitPage } from "../index";

declare var postingDateUrl: string;
declare var toleranceAbove: number;
declare var toleranceUnder: number;
declare var subZones: object;

class ErcPurchaseOrderReceivings {
  constructor() {
    const _this = this;
    $(function () {
      // @ts-ignore
      $(".date_picker_gray").datepicker({ format: "yyyy-mm-dd" });

      $(".calendar-fonticon").on("click", function (e) {
        e.preventDefault();
        const elm = $(e.currentTarget.previousElementSibling);
        const visible = elm.datepicker("widget").is(":visible");
        elm.datepicker(visible ? "hide" : "show");
      });

      $("#post_date").on("change", function (e) {
        const elm: any = e.currentTarget;
        if (Date.parse(elm.value) < 0) return;

        $.ajax({
          type: "PUT",
          url: postingDateUrl.replace(":id", elm.dataset.id),
          data: { posting_date: elm.value },
          success: function () {
            swal({
              icon: "success",
              title: "Posting Date has been saved",
              timer: 1500,
            });
          },
          error: function ({ responseJSON }) {
            swal({
              icon: "error",
              title: "Error",
              text: responseJSON.errors,
              dangerMode: true,
            });
          },
        });
      });

      $(".container-fluid").on("keyup", "input", function () {
        if (/item/.test(this.name)) {
          // @ts-ignore
          _this.validateRowByName(this.name);
        }
      });

      $(".container-fluid").on(
        "change",
        "select.zone-select",
        function (event: any) {
          const [id, index] = [...event.target.name.match(/\d+/g)];
          _this.loadSubZones(id, index, event.target.value);
          // @ts-ignore
          _this.validateRowByName(this.name);
        },
      );

      $(".container-fluid").on("change", "select.uom-select", function () {
        // @ts-ignore
        _this.validateRowByName(this.name);
      });

      $(".container-fluid").on("click", ".collapse-icon", function () {
        _this.toggleItems(this);
      });

      $(".container-fluid").on("click", ".add-icon", function () {
        _this.handleAddElement(this);
      });

      $(".container-fluid").on("click", ".print-action", function (elm: any) {
        elm.preventDefault();
        const id = elm.currentTarget.dataset.id;
        $(`#print-form-${id}`).trigger("submit");
      });

      // Bin Location must always reflect whichever Static Zone is actually
      // selected in that row, not whatever the server happened to render -
      // sync it on load rather than only on a manual zone change.
      $("select.zone-select").each(function () {
        const [id, index] = [...(this as HTMLSelectElement).name.match(/\d+/g)];
        const $subZoneSelect = $(`#item_${id}_${index}_sub_zone_id`);
        _this.loadSubZones(
          id,
          index,
          $(this).val() as string,
          $subZoneSelect.val() as string,
        );
      });
    });
  }

  toggleItems(elm: HTMLElement) {
    if ($(elm).hasClass("disable_link")) return;

    const id = $(elm).data("target").replace("#por_item_", "");
    const children = $(elm).children();
    $(elm).prev().toggle(); // Add button
    $(elm).prev().prev().toggle(); // Print button
    const not_current = $(".fa-hand-o-up").not(children).not($(".ignore"));
    not_current.toggleClass("disabled");
    not_current.parent().toggleClass("disable_link");
    not_current
      .parent()
      .parent()
      .prev()
      .children()
      .toggleClass("default-status");
    not_current.parent().parent().parent().toggleClass("text-muted"); // table row
    children.toggleClass("fa-hand-o-up text-primary fa-close text-danger");
    const tr = $(elm).parent().parent();
    if (!children.hasClass("fa-hand-o-up")) {
      tr.removeClass("item_row");
      $(`.toggle-${id}`).hide();
      $(elm).attr("title", "Cancel");

      const statuses = ["Pending", "Partially Received"];
      if (statuses.includes($(`#status-${id}`).text().trim())) {
        $(`#status-${id}`).text("In Progress");
        $(`#status-${id}`).attr("class", "table-status low-warning-status");
      }
    } else {
      tr.addClass("item_row");
      $(`.toggle-${id}`).show();
      $(elm).attr("title", "Receive");

      if ($(`#status-${id}`).text().trim() === "In Progress") {
        const received_qty = parseInt($(`#received-${id}`).text()) || 0;
        const expected_qty = parseInt($(`#expected-${id}`).text());
        if (received_qty === 0) {
          $(`#status-${id}`).text("Pending");
          $(`#status-${id}`).attr("class", "table-status default-status");
        } else if (received_qty >= expected_qty) {
          $(`#status-${id}`).text("Received");
          $(`#status-${id}`).attr("class", "table-status success-status");
        } else {
          $(`#status-${id}`).text("Partially Received");
          $(`#status-${id}`).attr("class", "table-status middle-status");
        }
      }
    }
  }

  validateRowByName(name: string) {
    const [id, index] = [...name.match(/\d+/g)];
    this.validateRow(id, index);
  }

  validateRow(id: string, index: string) {
    const rowValidation = this.getSubRowValidation(id, index);
    const icon = rowValidation.valid
      ? "<i class='fa fa-check-circle-o text-success fa-lg'></i>"
      : `<i class='fa fa-warning text-warning fa-lg' data-toggle='tooltip' title='${rowValidation.reason}'></i>`;
    $(`#valid-${id}-${index}`).html(icon);
    if (!rowValidation.valid) {
      $(`#valid-${id}-${index} [data-toggle="tooltip"]`).tooltip();
    }

    let valid = true;
    const regex = `valid-${id}-`;
    $("td")
      .filter((_, { id }: any) => id.match(regex))
      .each(function (_, elm) {
        const children = $(elm).children();
        if (children.hasClass("text-warning")) {
          valid = false;
          return false;
        } else if (children.hasClass("text-success")) {
          valid = true;
        }
      });

    if (valid) {
      $(`#print-${id}`).removeClass("disable_link disabled");
    } else {
      $(`#print-${id}`).addClass("disable_link disabled");
    }
  }

  // uom select options are valued by storage unit id, not name, so target uom
  // (a name like "CS") must be matched by option text, not option value.
  getMeasureUnitByName(id: string, uomName: string): number {
    const option = $(`select[name^="item[${id}]"][name$="[uom]"] option`)
      .filter((_, o: any) => $(o).text().trim() === uomName)
      .first();
    return parseFloat(option.data("mu")) || 1;
  }

  getRowMeasureUnit(id: string, index: string): number {
    const option = $(
      `select[name="item[${id}][${index}][uom]"] option:selected`,
    );
    return parseFloat(option.data("mu")) || 1;
  }

  isRowValid(id: string) {
    const expected_qty = parseInt($(`#expected-${id}`).text());
    const received_qty = parseInt($(`#received-${id}`).text()) + 0;
    const targetUom = $(`#table_${id}`).data("uom");
    const targetMu = this.getMeasureUnitByName(id, targetUom);
    const reg = new RegExp(`item\\[${id}\\]\\[\\d+\]\\[total_received_qty\\]`);
    const sum =
      $("input")
        .filter((_, { name }: any) => name.match(reg))
        .toArray()
        .reduce((total: any, input: any) => {
          const [, index] = [...input.name.match(/\d+/g)];
          const rowMu = this.getRowMeasureUnit(id, index);
          return total + (parseInt(input.value || 0) * rowMu) / targetMu;
        }, 0) + received_qty;
    const min = expected_qty * (1 - toleranceUnder / 100);
    const max = expected_qty * (1 + toleranceAbove / 100);

    return min <= sum && sum <= max;
  }

  isSubRowValid(id: string, index: string) {
    return this.getSubRowValidation(id, index).valid;
  }

  getSubRowValidation(
    id: string,
    index: string,
  ): { valid: boolean; reason: string } {
    const total_received_qty = this.getInt(id, index, "total_received_qty");
    const palletCount = this.getInt(id, index, "number_of_pallets");
    const boxCount = this.getInt(id, index, "number_of_boxes");
    const unitCount = this.getInt(id, index, "number_of_units");
    const additionalUnits = this.getInt(id, index, "additional_units") || 0;
    const subZone = $(
      `select[name="item[${id}][${index}][sub_zone_id]"]`,
    ).val();

    // Number of tags is whichever of pallets/boxes/units is set (in that
    // order of precedence); `qty` (quantity on a single tag) is the product
    // of whichever fields weren't used to determine the tag count. Mirrors
    // ERC::PurchaseOrderReceivingItemDetail#number_of_labels / #current_units.
    let qty = 1;
    let labels = 0;

    if (palletCount > 0) {
      labels = palletCount;
      if (boxCount > 0 && unitCount > 0) qty = boxCount * unitCount;
      else if (boxCount > 0) qty = boxCount;
      else if (unitCount > 0) qty = unitCount;
    } else if (boxCount > 0) {
      labels = boxCount;
      qty = unitCount > 0 ? unitCount : 1;
    } else if (unitCount > 0) {
      labels = unitCount;
    }

    const total = labels * qty + additionalUnits;

    if (total_received_qty === 0 || total_received_qty !== total) {
      return {
        valid: false,
        reason:
          "Total Received QTY does not match Pallets / Boxes / Units / Ad. Loose Unit(s)",
      };
    }
    if (!subZone) {
      return { valid: false, reason: "Please select a Bin Location" };
    }

    return { valid: true, reason: "" };
  }

  handleAddElement(elm: HTMLElement) {
    const _this = this;
    const id = $(elm).data("id");
    const lastRow = $(`#table_${id} tr:last`);
    const index = lastRow.data("index") + 1;

    const newRow = lastRow.clone();
    newRow.attr("data-index", index);

    let selectedZoneForNewRow = "";
    let selectedSubZoneForNewRow = "";

    newRow.children().each(function (i, e) {
      switch (i) {
        case 0:
          _this.resetFormElement(e, id, index, "total_received_qty");
          break;

        case 1:
          const select = $(e).children();
          select.attr("name", `item[${id}][${index}][uom]`);
          select.attr("id", `item[${id}][${index}][uom]`);
          const selected = $(
            `select[name="item[${id}][${index - 1}][uom]"]`,
          ).val();
          select
            .children()
            .filter(function () {
              return $(this).val() == selected;
            })
            .prop("selected", true);

          break;

        case 2:
          _this.resetFormElement(e, id, index, "number_of_pallets");
          break;

        case 3:
          _this.resetFormElement(e, id, index, "number_of_boxes");
          break;

        case 4:
          _this.resetFormElement(e, id, index, "number_of_units");
          break;

        case 5:
          _this.resetFormElement(e, id, index, "additional_units");
          break;

        case 6:
          // Clear the cell and create a fresh select element
          $(e).empty();
          const originalSelectZone = $(
            `select[name="item[${id}][${index - 1}][zone_id]"]`,
          );
          const selectZone = originalSelectZone.clone();
          selectZone.attr("name", `item[${id}][${index}][zone_id]`);
          selectZone.attr("id", `item_${id}_${index}_zone_id`);
          selectZone.removeClass("select2-hidden-accessible");
          selectZone.removeAttr("data-select2-id");
          selectZone.find("option").removeAttr("data-select2-id");

          // Get the selected value from the previous row
          const selectedZone = originalSelectZone.val();
          selectedZoneForNewRow = selectedZone as string;
          selectZone
            .children()
            .filter(function () {
              return $(this).val() == selectedZone;
            })
            .prop("selected", true);

          // Append the clean select to the cell
          $(e).append(selectZone);
          break;

        case 7:
          // Bin Location must match the new row's Static Zone - build an
          // empty select here and populate it via loadSubZones once the
          // row is attached to the document (below), instead of cloning
          // the previous row's possibly unrelated options.
          $(e).empty();
          $(e).append(
            $("<select>", {
              name: `item[${id}][${index}][sub_zone_id]`,
              id: `item_${id}_${index}_sub_zone_id`,
              class: "select2",
            }),
          );
          selectedSubZoneForNewRow = $(
            `select[name="item[${id}][${index - 1}][sub_zone_id]"]`,
          ).val() as string;
          break;

        case 8:
          $(e).text("");
          $(e).attr("id", `valid-${id}-${index}`);
          break;

        case 9:
          $(e).html(
            `<a title="Delete" data-toggle="tooltip" style="" class="add-icon" data-id="${id}" data-index=${index}><i class="fa fa-minus-circle fa-lg text-danger"></i></a>`,
          );
          $(e)
            .children()
            .on("click", function () {
              _this.handleRemoveElement(id, index);
            });
          break;
      }
    });

    lastRow.after(newRow);
    _this.loadSubZones(
      id,
      index,
      selectedZoneForNewRow,
      selectedSubZoneForNewRow,
    );

    $(".select2").select2();
    _this.validateRow(id, index);
  }

  handleRemoveElement(id: string, index: string) {
    $(`#table_${id} tr[data-index=${index}]`).remove();
    this.validateRow(id, "0");
  }

  resetFormElement(elm: HTMLElement, id: string, index: string, title: string) {
    const _this = this;
    const children = $(elm).children();
    children.attr("name", `item[${id}][${index}][${title}]`);
    children.attr("id", `item[${id}][${index}][${title}]`);
    children.val("");
    children.on("change", function () {
      _this.validateRow(id, index);
    });
  }

  loadSubZones(
    id: string,
    index: string,
    zoneId: string,
    selectedSubZoneId?: string,
  ) {
    const $select = $(`#item_${id}_${index}_sub_zone_id`);
    $select.empty();
    (subZones[zoneId] || []).forEach((subZone: any) => {
      $select.append(
        $("<option>", {
          value: subZone.id,
          text: subZone.name,
          selected: String(subZone.id) === selectedSubZoneId,
        }),
      );
    });
    $select.select2();
  }

  getInt(id: string, index: string, label: string): number {
    const item = `input[name="item[${id}][${index}][${label}]"]`;
    return parseInt($(item).val().toString());
  }
}

export function LoadPage() {
  InitPage("purchase_order_receivings", () => {
    new ErcPurchaseOrderReceivings();
  });
}
